import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CardEffects, cardReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([CardEffects]), StoreModule.forFeature(`card`, cardReducer)]
})
export class CardStateModule {}
